function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPfeil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 2",
    viewBox: "0 0 13.81 8.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13.81v8.26H0z",
    style: {
      strokeWidth: 0,
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 1",
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.06.75 6.88 7.18.75.81",
    style: {
      fill: "none",
      stroke: "#ff6641",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfeil);
export default __webpack_public_path__ + "static/media/Pfeil.3604e102dce5c94a0a05492e8eaaf5d9.svg";
export { ForwardRef as ReactComponent };